(function () {
  var COLORS = {
    silver: ['Hypersilber', '#C9C4B8'], white: ['Alpinweiss', '#E6E1D5'], titan: ['Titan', '#9C9A94'],
    graphite: ['Graphit', '#4A4844'], black: ['Schwarz', '#232221'], gold: ['Hirsch-Gold', '#B49455'],
    bronze: ['Bronze', '#8C6B3E'], oxblood: ['Ochsenblut', '#6B2A26']
  };
  // Unbekannte Farben (z. B. Herstellerfarben "matt-black") über Stichworte einfärben
  var HINTS = [['custom', 'conic-gradient(#B3121B, #C29A4E, #1C3F94, #0F3D2E, #B3121B)'], ['chameleon', 'linear-gradient(135deg,#5b3fa0,#2f8a6b)'], ['bronze', '#8C6B3E'], ['gold', '#B49455'], ['silver', '#C9C4B8'], ['white', '#E6E1D5'],
    ['gun', '#4A4844'], ['graphite', '#4A4844'], ['titan', '#9C9A94'], ['red', '#B3121B'], ['green', '#2E6B3A'], ['blue', '#1C3F94'], ['violet', '#5b3fa0'], ['black', '#232221']];
  var colorOf = function (id) {
    if (COLORS[id]) return COLORS[id];
    var label = id.split('-').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
    var hit = HINTS.filter(function (h) { return id.indexOf(h[0]) !== -1; })[0];
    return [label, hit ? hit[1] : '#777'];
  };

  document.querySelectorAll('[data-kol]').forEach(function (root) {
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var state = { types: [], colors: [], sizes: [], pcds: [], q: '' };
    var ddq = { colors: '', sizes: '', pcds: '' };
    var LIMIT = 6, expanded = { types: false, colors: false, sizes: false, pcds: false };
    var products = $$('[data-card]').map(function (el) {
      var split = function (v) { return (v || '').split(' ').filter(Boolean); };
      return { el: el, type: el.dataset.type || '', colors: split(el.dataset.colors),
        sizes: split(el.dataset.sizes).map(function (z) { return parseInt(z, 10); }).filter(function (z) { return !isNaN(z); }),
        pcds: split(el.dataset.pcds), name: el.dataset.name || '' };
    });

    // Gruppierung nach Bauart / Serie mit Überschriften (wie jr-wheels.com)
    var heads = [];
    var perGroup = parseInt(root.dataset.perGroup, 10) || 0;
    // Links pro Gruppe aus der Einstellung "Name=URL" (eine Zeile pro Gruppe)
    var groupLinks = {};
    (root.dataset.groupLinks || '').split(/\r?\n|;/).forEach(function (line) {
      var i = line.indexOf('=');
      if (i > 0) groupLinks[line.slice(0, i).trim()] = line.slice(i + 1).trim();
    });
    (function group() {
      var grid = root.querySelector('.kol__grid'), empty = root.querySelector('[data-empty]');
      var num = function (p) { var m = p.name.match(/d+/); return m ? parseInt(m[0], 10) : 0; };
      var sort = root.dataset.sort;
      if (sort === 'asc' || sort === 'desc') {
        products.sort(function (a, b) { return sort === 'asc' ? num(a) - num(b) : num(b) - num(a); });
      }
      var seen = [];
      products.forEach(function (p) { if (seen.indexOf(p.type) === -1) seen.push(p.type); });
      var useGroups = root.dataset.groupBy === 'true' && seen.length > 1;
      var order = (root.dataset.groupOrder || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var rank = function (t) { var i = order.indexOf(t); return i === -1 ? order.length + seen.indexOf(t) : i; };
      if (useGroups) seen.sort(function (a, b) { return rank(a) - rank(b); });
      (useGroups ? seen : [null]).forEach(function (type) {
        var members = products.filter(function (p) { return type === null || p.type === type; });
        if (useGroups) {
          var h = document.createElement('h2');
          h.className = 'kol__group-h';
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'kol__group-btn';
          btn.setAttribute('aria-expanded', 'true');
          btn.innerHTML = '<span class="kol__group-name"></span><small></small><i aria-hidden="true"></i>';
          btn.querySelector('.kol__group-name').textContent = type || 'Weitere';
          h.appendChild(btn);
          grid.insertBefore(h, empty);
          var entry = { el: h, btn: btn, type: type, open: true, all: false, more: null };
          btn.addEventListener('click', function () { entry.open = !entry.open; render(); });
          heads.push(entry);
        }
        members.forEach(function (p) { grid.insertBefore(p.el, empty); });
        // Pro Gruppe nur die ersten N Modelle, darunter "Weitere anzeigen"
        if (useGroups && perGroup > 0) {
          var e = heads[heads.length - 1];
          var link = groupLinks[type];
          var more;
          if (link) {
            // Link zur Kollektionsseite dieser Marke / Serie
            more = document.createElement('a');
            // Format "URL" oder "URL|Eigene Beschriftung"
            var parts = link.split('|');
            more.href = parts[0].trim();
            more.className = 'kol__group-more kol__group-link';
            var label = document.createElement('span');
            if (parts[1]) {
              label.textContent = parts[1].trim();
            } else {
              label.innerHTML = 'Alle <b></b> Felgen ansehen';
              label.querySelector('b').textContent = type;
            }
            var arrow = document.createElement('i');
            arrow.setAttribute('aria-hidden', 'true');
            arrow.textContent = '→';
            more.appendChild(label);
            more.appendChild(arrow);
            e.link = true;
          } else {
            more = document.createElement('button');
            more.type = 'button';
            more.className = 'kol__group-more';
            more.addEventListener('click', function () { e.all = !e.all; render(); });
          }
          grid.insertBefore(more, empty);
          e.more = more;
        }
      });
    })();

    // Farbpunkte auf den Karten
    $$('[data-dots]').forEach(function (box) {
      box.dataset.dots.split(' ').filter(Boolean).forEach(function (id) {
        var c = colorOf(id), s = document.createElement('span');
        s.title = c[0]; s.style.background = c[1];
        box.appendChild(s);
      });
    });

    // Filteroptionen aus den vorhandenen Produkten ableiten
    var uniq = function (arr) { return arr.filter(function (v, i) { return v && arr.indexOf(v) === i; }); };
    var types = uniq(products.map(function (p) { return p.type; }));
    var typeOrder = (root.dataset.groupOrder || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    types.sort(function (a, b) { var ia = typeOrder.indexOf(a), ib = typeOrder.indexOf(b); return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib); });
    var colorIds = uniq([].concat.apply([], products.map(function (p) { return p.colors; })));
    var order = Object.keys(COLORS), rank = function (id) { var i = order.indexOf(id); return i === -1 ? 99 : i; };
    colorIds.sort(function (a, b) { return rank(a) - rank(b); });
    var sizes = uniq([].concat.apply([], products.map(function (p) { return p.sizes; }))).sort(function (a, b) { return a - b; });

    var pcdKey = function (s) { var m = s.split('x'); return parseInt(m[0], 10) * 1000 + parseFloat(m[1]); };
    var pcdList = uniq([].concat.apply([], products.map(function (p) { return p.pcds; }))).sort(function (a, b) { return pcdKey(a) - pcdKey(b); });
    var groups = {
      types: types.map(function (t) { return { id: t, label: t, test: function (p) { return p.type === t; } }; }),
      colors: colorIds.map(function (id) { var c = colorOf(id); return { id: id, label: c[0], hex: c[1], test: function (p) { return p.colors.indexOf(id) !== -1; } }; }),
      sizes: sizes.map(function (z) { return { id: z, label: z + '″', test: function (p) { return p.sizes.indexOf(z) !== -1; } }; }),
      pcds: pcdList.map(function (x) { return { id: x, label: x, test: function (p) { return p.pcds.indexOf(x) !== -1; } }; })
    };
    // Gruppen ohne Auswahl (oder nur eine Option) ausblenden
    Object.keys(groups).forEach(function (k) { $$('[data-wrap="' + k + '"]').forEach(function (w) { w.hidden = groups[k].length < 2; }); });

    function match(p, skip) {
      var q = state.q.trim().toLowerCase();
      if (skip !== 'types' && state.types.length && state.types.indexOf(p.type) === -1) return false;
      if (skip !== 'colors' && state.colors.length && !state.colors.some(function (c) { return p.colors.indexOf(c) !== -1; })) return false;
      if (skip !== 'sizes' && state.sizes.length && !state.sizes.some(function (z) { return p.sizes.indexOf(z) !== -1; })) return false;
      if (skip !== 'pcds' && state.pcds.length && !state.pcds.some(function (x) { return p.pcds.indexOf(x) !== -1; })) return false;
      if (q && p.name.indexOf(q) === -1) return false;
      return true;
    }
    function toggle(key, id) {
      var i = state[key].indexOf(id);
      if (i === -1) state[key].push(id); else state[key].splice(i, 1);
      render();
    }
    function dot(hex) {
      var s = document.createElement('span');
      s.className = 'kol__dot'; s.setAttribute('aria-hidden', 'true'); s.style.background = hex;
      return s;
    }
    function renderGroup(key) {
      $$('[data-group="' + key + '"]').forEach(function (box) {
        box.innerHTML = '';
        groups[key].forEach(function (o) {
          var on = state[key].indexOf(o.id) !== -1;
          var n = products.filter(function (p) { return match(p, key) && o.test(p); }).length;
          if (box.dataset.mode === 'list') {
            var needle = (ddq[key] || '').trim().toLowerCase();
            if (needle && !on && String(o.label).toLowerCase().indexOf(needle) === -1) return;
            var lab = document.createElement('label');
            lab.className = 'kol__opt' + (n ? '' : ' is-zero');
            var cb = document.createElement('input');
            cb.type = 'checkbox'; cb.checked = on;
            cb.addEventListener('change', function () { toggle(key, o.id); });
            lab.appendChild(cb);
            if (o.hex) lab.appendChild(dot(o.hex));
            var t = document.createElement('span'); t.textContent = o.label; lab.appendChild(t);
            var c = document.createElement('span'); c.className = 'kol__n'; c.textContent = n; lab.appendChild(c);
            box.appendChild(lab);
          } else {
            var b = document.createElement('button');
            b.type = 'button'; b.className = 'kol__chip'; b.setAttribute('aria-pressed', on ? 'true' : 'false');
            if (o.hex) b.appendChild(dot(o.hex));
            b.appendChild(document.createTextNode(o.label));
            b.addEventListener('click', function () { toggle(key, o.id); });
            box.appendChild(b);
          }
        });
        // Desktop-Liste: nach 6 Einträgen "Mehr anzeigen" (gewählte bleiben sichtbar, Suche zeigt alle Treffer)
        if (box.dataset.mode === 'list' && !(ddq[key] || '').trim()) {
          var labels = Array.prototype.slice.call(box.querySelectorAll('.kol__opt'));
          if (labels.length > LIMIT) {
            var hiddenCount = 0;
            if (!expanded[key]) {
              labels.forEach(function (l, i) {
                if (i >= LIMIT && !l.querySelector('input').checked) { l.hidden = true; hiddenCount++; }
              });
            }
            var more = document.createElement('button');
            more.type = 'button';
            more.className = 'kol__more';
            more.textContent = expanded[key] ? 'Weniger anzeigen' : 'Mehr anzeigen (+' + hiddenCount + ')';
            more.setAttribute('aria-expanded', expanded[key] ? 'true' : 'false');
            more.addEventListener('click', function () { expanded[key] = !expanded[key]; renderGroup(key); });
            if (expanded[key] || hiddenCount) box.appendChild(more);
          }
        }
      });
    }
    function render() {
      var count = 0;
      products.forEach(function (p) { var ok = match(p); p.el.hidden = !ok; if (ok) count++; });
      heads.forEach(function (h) {
        var members = products.filter(function (p) { return p.type === h.type && !p.el.hidden; });
        h.el.hidden = members.length === 0;
        h.btn.querySelector('small').textContent = members.length === 1 ? '1 Modell' : members.length + ' Modelle';
        h.btn.setAttribute('aria-expanded', h.open ? 'true' : 'false');
        if (!h.open) members.forEach(function (p) { p.el.hidden = true; });
        if (h.more) {
          var extra = members.length - perGroup;
          if (h.open && !h.all && extra > 0) members.slice(perGroup).forEach(function (p) { p.el.hidden = true; });
          if (h.link) {
            h.more.hidden = !h.open || members.length === 0;
          } else {
            h.more.hidden = !h.open || extra <= 0;
            h.more.textContent = h.all ? 'Weniger anzeigen' : 'Weitere ' + (h.type || '') + ' anzeigen (+' + Math.max(extra, 0) + ')';
          }
        }
      });
      ['types', 'colors', 'sizes', 'pcds'].forEach(renderGroup);
      var label = count === 1 ? '1 Modell' : count + ' Modelle';
      $$('[data-count]').forEach(function (e) { e.textContent = label; });
      if (products.length) $$('[data-empty]').forEach(function (e) { e.hidden = count !== 0; });
      var active = state.types.length + state.colors.length + state.sizes.length + state.pcds.length;
      $$('[data-active]').forEach(function (e) { e.textContent = active ? 'Filter (' + active + ')' : 'Filter'; });
      $$('[data-reset-top]').forEach(function (e) { e.hidden = active === 0 && !state.q; });
      ['colors', 'sizes', 'pcds'].forEach(function (k) {
        $$('[data-dd-count="' + k + '"]').forEach(function (e) { e.textContent = state[k].length ? state[k].length + ' gewählt' : ''; });
      });
    }
    function reset() {
      state.types = []; state.colors = []; state.sizes = []; state.pcds = []; state.q = '';
      $$('[data-search]').forEach(function (i) { i.value = ''; });
      render();
    }
    $$('[data-search]').forEach(function (i) { i.addEventListener('input', function () { state.q = i.value; render(); }); });
    $$('[data-reset]').forEach(function (b) { b.addEventListener('click', reset); });
    // Suche innerhalb der Filter-Dropdowns
    $$('[data-dd-search]').forEach(function (inp) {
      var k = inp.getAttribute('data-dd-search');
      inp.addEventListener('input', function () { ddq[k] = inp.value; renderGroup(k); });
    });

    // Mobil: Filter als Sheet von unten
    var sheet = root.querySelector('[data-sheet]'), opener = root.querySelector('[data-open]');
    function setSheet(open) {
      sheet.hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) { var f = sheet.querySelector('.kol__panel button'); if (f) f.focus(); } else if (opener) opener.focus();
    }
    if (opener) opener.addEventListener('click', function () { setSheet(true); });
    $$('[data-close]').forEach(function (b) { b.addEventListener('click', function () { setSheet(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) setSheet(false); });

    // Suchbegriff aus dem Link übernehmen (?q=…), z. B. von der Felgen-Suche auf der Startseite
    try {
      var q0 = new URLSearchParams(window.location.search).get('q');
      if (q0) {
        state.q = q0;
        $$('[data-search]').forEach(function (i) { i.value = q0; });
      }
    } catch (err) { /* ohne Vorbelegung */ }

    render();

    // Darstellung "Eine Reihe mit Slider": Pfeile links/rechts, nur sichtbar wenn es weitergeht
    if (root.classList.contains('kol--slider')) {
      var grid = root.querySelector('.kol__grid');
      var wrap = document.createElement('div');
      wrap.className = 'kol__slidewrap';
      grid.parentNode.insertBefore(wrap, grid);
      wrap.appendChild(grid);
      var mk = function (dir, label, txt) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'kol__arrow kol__arrow--' + dir; b.setAttribute('aria-label', label); b.textContent = txt;
        b.addEventListener('click', function () {
          var card = grid.querySelector('[data-card]:not([hidden])');
          var step = card ? card.offsetWidth + 20 : grid.clientWidth * 0.8;
          grid.scrollBy({ left: dir === 'prev' ? -step : step, behavior: 'smooth' });
        });
        wrap.appendChild(b);
        return b;
      };
      var prev = mk('prev', 'Vorherige Felge', '‹'), next = mk('next', 'Nächste Felge', '›');
      var upd = function () {
        var max = grid.scrollWidth - grid.clientWidth;
        prev.hidden = grid.scrollLeft <= 2;
        next.hidden = grid.scrollLeft >= max - 2;
      };
      grid.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    }
  });
})();
